import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { SiteProvider } from "@/context/SiteContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import Home from "@/pages/Home";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetail from "@/pages/ServiceDetail";
import ProjectsPage from "@/pages/ProjectsPage";
import BeforeAfterPage from "@/pages/BeforeAfterPage";
import ReviewsPage from "@/pages/ReviewsPage";
import EstimatePage from "@/pages/EstimatePage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";
import PortalLogin from "@/portal/PortalLogin";
import PortalLayout from "@/portal/PortalLayout";
import Dashboard from "@/portal/Dashboard";
import LeadsPage from "@/portal/LeadsPage";
import LeadDetail from "@/portal/LeadDetail";
import GalleryManager from "@/portal/GalleryManager";
import BeforeAfterManager from "@/portal/BeforeAfterManager";
import ReviewsManager from "@/portal/ReviewsManager";
import ServicesManager from "@/portal/ServicesManager";
import ResetPassword from "@/portal/ResetPassword";
import PortalSettings from "@/portal/PortalSettings";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);
  return (
    <>
      <Header />
      <Outlet key={pathname} />
      <Footer />
      <ChatWidget />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <SiteProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/before-after" element={<BeforeAfterPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/estimate" element={<EstimatePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/privacy" element={<LegalPage type="privacy" />} />
              <Route path="/terms" element={<LegalPage type="terms" />} />
            </Route>
            <Route path="/portal/login" element={<PortalLogin />} />
            <Route path="/portal/reset-password" element={<ResetPassword />} />
            <Route path="/portal" element={<PortalLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="leads" element={<LeadsPage />} />
              <Route path="leads/:id" element={<LeadDetail />} />
              <Route path="gallery" element={<GalleryManager />} />
              <Route path="before-after" element={<BeforeAfterManager />} />
              <Route path="services" element={<ServicesManager />} />
              <Route path="reviews" element={<ReviewsManager />} />
              <Route path="settings" element={<PortalSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </SiteProvider>
    </div>
  );
}

export default App;
